__turbopack_context__.v({
  "cardIcon": "WHoHpW_cardIcon",
});
